import { put, call, take, fork } from 'redux-saga/effects'
import { courseListService } from '../../api/course'
import { courseListSuccess } from '../../reducers/course/action'
import { COURSE_LIST } from '../../reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseListFlow(payload) {
  try {
    const { query, callback } = payload
    const response = yield call(courseListService, query)
    callback(response)
    yield put(courseListSuccess(response.data))
    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseListWatcher() {
  while (true) {
    const action = yield take(COURSE_LIST)
    const { payload } = action

    yield fork(generalSaga, courseListFlow, payload)
  }
}
